import axios from '../../apis/apicidtech';
import { types } from '../../types/types';
import { getToken } from '../../utils/tokencidtechapi';
import { dispatchpending, dispatchresponse, dispatchresponseerror } from '../utils/dispatches';

export const novoatualiza = (dados = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.put('helpers/emails/novoatualiza',
                {
                    ...dados
                },
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data,types.EMAIL.NOVOATUALIZA);

            return response.data;

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const pesquisa = (filtro = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('helpers/emails/pesquisa',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...filtro
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data?response.data:{},types.EMAIL.PESQUISA);

            return response.data?response.data:{};

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const pesquisaPalavrasChaves = (filtro = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('credenciais/credencial/email/palavraschaves',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...filtro
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data?response.data:{},types.EMAIL.PESQUISACHAVES);

            return response.data?response.data:{};

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const pesquisaEmailRenderiza = (filtro = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('credenciais/credencial/email/renderizar',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...filtro
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data?response.data:{},types.EMAIL.RENDERIZAR);

            return response.data?response.data:{};

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const pesquisaTipos = (filtro = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('termos/tipos/pesquisa',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...filtro
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data?response.data:{},types.EMAIL.PESQUISATIPOS);

            return response.data?response.data:{};

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const pesquisaTiposEmails = (filtro = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('helpers/emails/tipos/pesquisa',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...filtro
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data?response.data:{},types.EMAIL.PESQUISATIPOSEMAIL);

            return response.data?response.data:{};

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const notificacaoemail = (filtro = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('helpers/email/envia/notificacoes',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...filtro
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data?response.data:{},types.EMAIL.ENVIAEMAILNOTIFICACAO);

            return response.data?response.data:{};

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}